/* eslint-disable prettier/prettier */
import React, { useContext } from 'react';
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { WindowContext } from 'contexts/WindowContext';

const PoolStatusChip = ({ pool }) => {
    const { isMobile } = useContext(WindowContext);
    const useStyles = makeStyles({
        chipCustom: {
            '& .MuiChip-label': { fontSize: isMobile ? 12 : 13 }
        }
    });
    const styles = useStyles();

    switch (pool?.status) {
        case 'completed':
            return <Chip label="Completed" color="success" variant="filled" className={styles.chipCustom} />;
        case 'waiting':
            return <Chip label="Not Started" color="error" variant="filled" className={styles.chipCustom} />;
        case 'in_progress':
            if (pool?.pool_teams[0]?.won === 0 && pool?.pool_teams[0]?.lost === 0) {
                return <Chip label="Not Started" color="error" variant="filled" className={styles.chipCustom} />;
            }
            return <Chip label="In Progress" color="warning" variant="filled" className={styles.chipCustom} />;
        default:
            return <Chip label="Playing" color="success" variant="filled" className={styles.chipCustom} />;
    }
};

export default PoolStatusChip; 